export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// ./src/app/containers/index.ts